import dayjs from 'dayjs';
import {Yup } from '../../utils/yup-locale'
import { TIME_OFFSET } from '../../features/Parking/utils';

export interface ParkingFilters {
  entryDate: string;
  entryTime: string;
  exitDate: string;
  exitTime: string;
  numberOfVehicles: number;
}


export const parkingFiltersSchema = Yup.object().shape({
  entryDate: Yup.string().required().test('entryDate', 'Entry date must be less than exit date', function (value) {
    const { exitDate } = this.parent;
    
    return value <= exitDate;
  }),
  // If the entry date is the current date. The entry time must be greater than the current time
  entryTime: Yup.string().required().test('entryTime', 'Entry time must be greater than current time', function (value) {
    const {entryDate} = this.parent;
    
    // current date into UTC format
    const currentDate = dayjs()
    const currentDateUTC = currentDate.add(TIME_OFFSET, 'hours').utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')

    if (entryDate > currentDate.format('YYYY-MM-DD')) return true;
    return value > currentDateUTC;
  }),
  exitDate: Yup.string().required(),
  // exitTime must be greater than entryTime if entryDate is equal to exitDate
  exitTime: Yup.string().required().test('exitTime', 'Exit time must be greater than entry time', function (value) {
    const { entryDate, exitDate, entryTime } = this.parent;
    if (entryDate === exitDate) {
      return value > entryTime;
    }
    return true;
  }),  
  numberOfVehicles: Yup.number().required(),
});